import { action, flow, makeObservable, observable } from 'mobx';
import { ApiServices } from '@pascal/pascal-core';
import { userSettingsStore } from '@pascal/pascal-core/shared/core/store/userSettingsStore';
import { ApiServiceNames } from '../enums';

class BonusIslandStore {
  ranges = {};

  selectedRange = { isLoading: false, data: {} };

  liveUpdateData = {
    playerExternalId: 0,
    userId: 0,
    selectionId: 0,
    winAmount: 0,
    isCollected: false,
  };

  isBonusIslandOpen = false;

  constructor() {
    makeObservable(this, {
      ranges: observable,
      isBonusIslandOpen: observable,
      selectedRange: observable.deep,
      liveUpdateData: observable.deep,
      setRanges: action.bound,
      setSelectedRange: action.bound,
      setIsBonusIslandOpen: action.bound,
      getCurrentBonusIslandData: flow.bound,
      handleUserTournamentInfo: action.bound,
    });
  }

  setRanges(ranges) {
    this.ranges = ranges;
  }

  setSelectedRange(selectedRange) {
    this.selectedRange = selectedRange;
  }

  setIsBonusIslandOpen(isBonusIslandOpen) {
    this.isBonusIslandOpen = isBonusIslandOpen;
  }

  handleUserTournamentInfo(liveUpdateData) {
    this.liveUpdateData = liveUpdateData;
  }

  *getCurrentBonusIslandData(params) {
    if (params) {
      this.setSelectedRange({ isLoading: true, data: {} });
    }
    const response = yield ApiServices.get(ApiServiceNames.BonusIslandService).getBonusIslandData(
      params
    );
    if (params) {
      this.setSelectedRange({ isLoading: false, data: response.data.result });
    } else {
      if (response.data?.result) {
        userSettingsStore.updateLocalStorage({ isBonusIslandNotifier: true });
        this.setRanges(response.data.result || {});
      } else {
        userSettingsStore.updateLocalStorage({ isBonusIslandNotifier: false });
      }
    }
  }
}

export const bonusIslandStore = new BonusIslandStore();
